import * as React from 'react';

const ExpandSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="expand_svg__eds-icon--expand_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="expand_svg__eds-icon--expand_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#010101"
            d="M2 2v10h1V3.7L20.3 21H12v1h10V12h-1v8.3L3.7 3H12V2z"
        />
    </svg>
);

ExpandSvg.displayName = 'ExpandSvg';
export default ExpandSvg;
